import { FileItem } from 'src/types/file-item';

export class UploadFilesPageState {
  public files: Array<FileItem>;

  constructor() {
    this.files = [];
  }
}
